export default __webpack_public_path__ + "static/media/twitter.021d6f8a.png";